import type { ApiErrorWithMeta } from 'api/interceptors';

const asApiError = (error: unknown): ApiErrorWithMeta | undefined =>
  typeof error === 'object' && error !== null
    ? (error as ApiErrorWithMeta)
    : undefined;

export const getApiErrorStatus = (error: unknown): number | undefined =>
  asApiError(error)?.status;

export const getApiErrorDetail = (error: unknown, fallback: string): string => {
  const detail = asApiError(error)?.data?.detail;

  return typeof detail === 'string' && detail ? detail : fallback;
};
